import {
  Directive,
  forwardRef,
  HostBinding,
  Renderer2,
  ElementRef,
  ChangeDetectorRef,
  Attribute,
  HostListener
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { TextFormElement } from "../text/text-form-element";

@Directive({
    selector: "input[acInputSearch]",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputSearchDirective),
            multi: true
        }
    ],
    standalone: false
})
export class InputSearchDirective extends TextFormElement {
  @HostBinding("autocomplete") autocomplete = "off";

  @HostListener("blur", ["$event"])
  onblur(event) {
    this.change(event.target.value);
  }

  @HostListener("ngbTypeahead", ["$event"])
  onchange(event) {}

  constructor(
    protected renderer: Renderer2,
    protected el: ElementRef,
    protected csRef: ChangeDetectorRef,
    @Attribute("updateEvent") protected updateEvent
  ) {
    super(renderer, el, csRef, updateEvent);
  }
}
